import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import ApiService from 'redux/services/api-service';
import {addResultCases} from 'utils/helpers';
import {SystemMessage, ListResult} from 'utils/types';

export interface IState {
  systemMessages: ListResult<SystemMessage>;
}

export const systemMessageEndpoints = {
  getSystemMessages: createAsyncThunk('systemMessage/getSystemMessages', async () => {
    const response = await ApiService.get('/system_messages/');
    return response.data;
  }),
};

export const systemMessageSlice = createSlice({
  name: 'systemMessage',
  initialState: {
    systemMessages: {as: 'idle'},
  } as IState,
  reducers: {},
  extraReducers: builder => {
    addResultCases(builder, systemMessageEndpoints.getSystemMessages, 'systemMessages');
  },
});

export type SystemMessageSlice = {
  [systemMessageSlice.name]: ReturnType<(typeof systemMessageSlice)['reducer']>;
};
